import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface CancelDowngradeScheduleModalProps {
  confirmText: string;
  description: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  showModal: boolean;
  title: string;
}
export const CancelDowngradeScheduleModal = ({
  showModal,
  onClose,
  onConfirm,
  title,
  confirmText,
  description,
  isLoading = false,
}: CancelDowngradeScheduleModalProps) => (
  <ConfirmationModal
    isOpen={showModal}
    onClose={onClose}
    confirmVariant="circle"
    size="md"
    onConfirm={onConfirm}
    title={title}
    confirmText={confirmText}
    disabled={isLoading}
  >
    <Typography.LabelMd>{description}</Typography.LabelMd>
  </ConfirmationModal>
);
